import React, { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { StatusHandler } from '../../../components'
import { fetchOrganizations } from '../slice'
import { organizationsContext } from './context'

const OrganizationsProvider = ({children}) => {
  const dispatch = useDispatch()
  const query = useSelector(state => state.organizations.query)
  const status = useSelector(state => state.organizations.status)
  const error = useSelector(state => state.organizations.error)
  const organizations = useSelector(state => state.organizations.data)

  useEffect(() => {
    if(status === 'idle'){
      console.log('organization provider dispatch fetch organizations')
      dispatch(fetchOrganizations(query))
    }
  }, [status, dispatch, query])

  return (
    <organizationsContext.Provider value={{ organizations }}>
      <StatusHandler
        status={status}
        error={error}
        onRetry={() => dispatch(fetchOrganizations(query))}
      >
        {children}
      </StatusHandler>
    </organizationsContext.Provider>
  )
}

export { OrganizationsProvider }
